// Pure contact-identity normalization. Mirrors the SQL resolver in
// supabase/migrations/<ts>_crm_contact_resolver.sql — KEEP THE TWO IN SYNC:
// if you change matching here, change resolve_contact()'s normalization too.

export function normalizeEmail(raw: string | null | undefined): string | null {
  const v = (raw ?? "").trim().toLowerCase();
  return v.length > 0 ? v : null;
}

export function normalizePhone(raw: string | null | undefined): string | null {
  let v = (raw ?? "").trim();
  if (!v) return null;
  const plus = v.startsWith("+") || v.startsWith("00");
  if (v.startsWith("00")) v = v.slice(2);
  const digits = v.replace(/\D/g, "");
  if (digits.length === 0) return null;
  return plus ? `+${digits}` : digits;
}

export function contactDisplayName(c: {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}): string {
  return c.name?.trim() || c.email?.trim() || c.phone?.trim() || "—";
}
